import React from 'react';
import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client'
import './index.css';
import { Provider } from 'react-redux';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { applyHubSwitchFromUrl, bootstrapHubSession } from './shared/hubAuth';
import { apiUrl } from './shared/url';

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

const root = createRoot(document.getElementById('root'))

// The store's initial auth state and the socket module read the session at
// import time, so with the identity hub on (REACT_APP_AUTH_HUB) the refresh
// cookie is turned into an access token before either loads. With the flag
// off bootstrapHubSession resolves at once and nothing changes.
// A ?hub=on|off link sets this device's switch first (pilot from a phone).
applyHubSwitchFromUrl();
bootstrapHubSession(apiUrl)
  .catch(() => false)
  .then(() => Promise.all([import('./app/store'), import('./App')]))
  .then(([{ store }, { default: App }]) => {
    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    )
  })
  .catch((err) => {
    // A failed chunk load would otherwise leave a blank page with no hint.
    console.error('No se pudo cargar la aplicación', err);
    root.render(<p style={{ padding: 24, fontFamily: 'sans-serif' }}>No se pudo cargar la aplicación. Recarga la página.</p>)
  })

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register();
